import { isEmpty } from 'lodash'
import * as ActionTypes from 'actions/ActionTypes'
import { SOURCE_FILE_TYPES } from '~/enums'
import * as Selectors from '~/selectors'
import NotFoundMediaImage from '~/assets/projects/not_found_media.png'
import { checkNWJsMediaExistence, getNWJsMediaExistence, getMediaFile } from '~/ServerAPI'
import { updateSourceFile } from '~/actions/sourceFiles'

export const getNWJsMediaExistenceAction = () => async (dispatch, getState) => {
  try {
    const sourceFiles = Selectors.getSourceFiles(getState(), SOURCE_FILE_TYPES.MEDIA) ?? []
    const ids = sourceFiles.map(file => file.id)
    const { data } = await checkNWJsMediaExistence(ids)
    if (data?.id) {
      const response = await getNWJsMediaExistence(data?.id)
      if (!isEmpty(response.data?.missingFileIds)) {
        const { missingFileIds } = response.data
        const files = sourceFiles.filter(f => missingFileIds.includes(f.id))
        const result = files.map(async file => {
          const res = await getMediaFile(file.id, SOURCE_FILE_TYPES.MEDIA, null, false)
          const { data } = res
          if (data.error) {
            await dispatch(updateSourceFile(data))
            dispatch({
              type: ActionTypes.ASSET_PROPERTY_UPDATE,
              payload: {
                id: file.id,
                newData: {
                  thumbnail: NotFoundMediaImage,
                  mediaDeleted: true,
                  errorMessage: 'Media file not found',
                },
              },
            })
          }
        })
        await Promise.all(result)
      }
    }
  } catch (e) {
    console.error(`getNWJsMediaExistence ${e}`)
  }
}
